export const SHOW_ID = 'showID';
export const CHECKED_TERMS = 'checkedTerms';
export const CHECKED_COVER = 'checkedCover';
export const OFFERT_MODE = 'offertMode';
export const NEW_PAGE_PER_POSITION = 'newPagePerPosition';
export const DISPLAY_OPTION = 'displayOption';
export const INCLUDE_MAGICLOUD_LINK = 'includeMagicloudLink';